export const enum PushType {
  Push = 'push',
  Pull = 'pull',
  FBB = 'fbb',
  Check = 'check'
}

export const mapper: Record<PushType, string> = {
  [PushType.Push]: 'Push',
  [PushType.Pull]: 'Pull',
  [PushType.FBB]: 'FBB',
  [PushType.Check]: 'Check'
}
